export const footer = {
  main:  { light: "#e2e6ef", dark: "#121d36" },
  text:  { light: "#121d36", dark: "#e2e6ef" }
};
